import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import PlanForm from '@/pages/plan/components/PlanForm';

const PlanNewPage: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className="title flex">
          <span
            className="pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer"
            onClick={() => navigate(PATH.plan)}
          ></span>
          <span className="ml-3">{t('plan.add_new')}</span>
        </h2>
      </div>
      <PlanForm />
    </>
  );
};

export default PlanNewPage;
